import {Action, ReducerBuilder} from "redux-ts";
import {Reducer} from "platform/redux/Reducer";
import {AppReduxState} from "core/redux/app/AppReduxState";
import {
    BannerPayload,
    DoGetURLType,
    RemoveBanner,
    SetActiveToolMenu,
    SetActiveToolMenuPayload,
    SetBanner, SetBarBottomMetrics,
    SetBarMetricsPayload,
    SetBarTopMetrics,
    SetConfiguredCountries,
    SetConfiguredCountriesPayload,
    SetTradingModal,
    SetTradingModalPayload,
    ToggleMenu,
    ToggleMenuPayload
} from "core/redux/app/AppReduxActions";
import {TSMap} from "typescript-map";
import Utils from "platform/util/Utils";
import {RouteType} from "core/router/Routes";
import {OnAccountChanged, OnLoggedOut, SetAuthStatusType} from "core/redux/auth/AuthReduxActions";
import ToolsMenuType from "enum/ToolsMenuType";
import AppEngine from "core/engine/AppEngine";
import {CountryInfo} from "platform/protocol/common/CountryInfo";
import {SetAppReadyType} from "platform/redux/core/CoreActions";

const initialState = (): AppReduxState => {
    return {
        countries: new TSMap<number, CountryInfo>(),
        namePerCountry: new TSMap<string, CountryInfo>(),
        availableMenuRoutes: [
            RouteType.AccountOverview,
            RouteType.Symbols,
            RouteType.MyTrades,
            RouteType.News,
            RouteType.EconomicCalendar,
            RouteType.TradingOpportunities,
            RouteType.Lessons,
            // RouteType.Promotions,
            RouteType.AccountSettings,
        ],
        modals: new TSMap(),
        activeToolMenu: ToolsMenuType.News,
        activeTools: [
            ToolsMenuType.News,
            ToolsMenuType.EconomicCalendar,
            ToolsMenuType.TradingOpportunities,
            ToolsMenuType.Lessons,
            ToolsMenuType.AccountSettings,
            ToolsMenuType.LiveChat,
        ],
        openMenu: true,
        blockedBanners: [],
        topBar: {height: 0},
        bottomBar: {height: 0}
    };
};

export default class AppReducer extends Reducer<AppReduxState> {

    private static _instance: AppReducer;

    public static instance(): AppReducer {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        super();
        const appEngine: AppEngine = AppEngine.instance();
        this._middlewareActions.set(SetAppReadyType, appEngine.onAppReady);
        this._middlewareActions.set(SetAuthStatusType, appEngine.doSetAuthStatus);
        this._middlewareActions.set(DoGetURLType, appEngine.doGetUrl);
    }

    public get name(): string {
        return "app";
    }

    protected setup(builder: ReducerBuilder<AppReduxState>): void {
        builder
            .init(initialState())
            .handle(OnLoggedOut, (state: AppReduxState, action: Action<any>) => {
                return {
                    ...initialState()
                };
            })
            .handle(OnAccountChanged, (state: AppReduxState, action: Action<any>) => {
                return Object.assign({}, state, {
                    banner: null
                });
            })
            .handle(SetConfiguredCountries, (state: AppReduxState, {payload}: Action<SetConfiguredCountriesPayload>) => {
                const newState: AppReduxState = Utils.merge({}, state);
                newState.countries = payload.countries;
                newState.namePerCountry = payload.namePerCountry;
                return newState;
            })
            .handle(SetTradingModal, (state: AppReduxState, {payload}: Action<SetTradingModalPayload<any>>) => {
                const newState: AppReduxState = Utils.merge({}, state);
                newState.modals.set(payload.tradingModalType, payload.info);
                return newState;
            })
            .handle(ToggleMenu, (state: AppReduxState, {payload}: Action<ToggleMenuPayload>) => {
                return Object.assign({}, state, {
                    openMenu: !payload.collapse
                })
            })
            .handle(SetActiveToolMenu, (state: AppReduxState, {payload}: Action<SetActiveToolMenuPayload>) => {
                return Object.assign({}, state, {
                    activeToolMenu: payload.toolType
                });
            })
            .handle(SetBanner, (state: AppReduxState, {payload}: Action<BannerPayload>) => {
                return Object.assign({}, state, {
                    banner: payload.banner
                });
            })
            .handle(RemoveBanner, (state: AppReduxState, {payload}: Action<BannerPayload>) => {
                const newState: AppReduxState = Utils.merge({}, state);
                newState.banner = null;
                if (Utils.isNull(payload.banner.remoteId)) {
                    newState.blockedBanners = [...newState.blockedBanners, payload.banner.type];
                }
                return newState;
            })
            .handle(SetBarTopMetrics, (state: AppReduxState, {payload}: Action<SetBarMetricsPayload>) => {
                const newState: AppReduxState = Utils.merge({}, state);
                newState.topBar = {...state.topBar, ...payload.metrics};
                return newState;
            })
            .handle(SetBarBottomMetrics, (state: AppReduxState, {payload}: Action<SetBarMetricsPayload>) => {
                const newState: AppReduxState = Utils.merge({}, state);
                newState.bottomBar = {...state.bottomBar, ...payload.metrics};
                return newState;
            });
    }
}
